export const SteeringWheelIcon = ({ className }) => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_3117_94540)">
        <path
          d="M40 47.5C42.0711 47.5 43.75 45.8211 43.75 43.75C43.75 41.6789 42.0711 40 40 40C37.9289 40 36.25 41.6789 36.25 43.75C36.25 45.8211 37.9289 47.5 40 47.5Z"
          fill="#A5A5A5"
        />
        <path
          d="M40 70C56.5685 70 70 56.5685 70 40C70 23.4315 56.5685 10 40 10C23.4315 10 10 23.4315 10 40C10 56.5685 23.4315 70 40 70Z"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5078 45.4844C14.2553 41.392 18.8132 38.1241 23.8919 35.8885C28.9706 33.6528 34.4588 32.4983 40.0078 32.4983C45.5568 32.4983 51.045 33.6528 56.1237 35.8885C61.2024 38.1241 65.7603 41.392 69.5078 45.4844"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.4375 69.8906L30.6063 51.625C30.428 51.148 30.1084 50.7368 29.6901 50.4464C29.2718 50.156 28.7748 50.0003 28.2656 50H11.7031"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.5391 69.8938L49.3828 51.6219C49.5617 51.145 49.8821 50.7341 50.3009 50.4442C50.7198 50.1544 51.2172 49.9994 51.7266 50H68.2891"
          stroke="#A5A5A5"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3117_94540">
          <rect width="80" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
